import React from "react";
import RadioButtonComponent, { ItemTypeProps } from "../RadioButtonComponent";
import { styled } from "styled-components";
import { Label, LabelAndInfo } from "./InputContainer";

export interface WrappedRadioButton {
  itemTypes: ItemTypeProps[];
  onTypeChange: (value: string) => void;
  activeType: string;
  label: string;
}
const WrappedRadioButton: React.FC<WrappedRadioButton> = ({
  itemTypes,
  onTypeChange,
  activeType,
  label,
}) => {
  return (
    <>
      <LabelAndInfo>
        <Label htmlFor={label}>{label}</Label>
      </LabelAndInfo>
      <Wrapper>
        <RadioButtonComponent
          itemTypes={itemTypes}
          onTypeChange={onTypeChange}
          activeType={activeType}
          hasBorder
          center
        />
      </Wrapper>
    </>
  );
};

export const Wrapper = styled.div`
  padding: 8px 0;
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: center;
`;
export default WrappedRadioButton;
